import { useState, useRef } from "react";
import "./forms.css";
import { auth } from "./firebase";
import { useHistory, Link } from "react-router-dom";
import {
  getAuth,
  EmailAuthProvider,
  updatePassword,
  reauthenticateWithCredential,
} from "firebase/auth";
import { useAuthValue } from "./AuthContext";
import TextField from "@mui/material/TextField";
import CssBaseline from "@mui/material/CssBaseline";
import { styled, createTheme, ThemeProvider } from "@mui/material/styles";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Toolbar from "@mui/material/Toolbar";
import MuiAppBar from "@mui/material/AppBar";
import AdminMenu from "./AdminMenu";
import Copyright from "./footer";
import AdminListItems from "./MenuList";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";

const theme = createTheme();

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "",
})(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
  backgroundColor: "#009944",
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
}));

function AdminChangePW() {
  const { currentUser } = useAuthValue();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [updated, setUpdated] = useState(false);
  const [inputError, setInputError] = useState(false);
  const history = useHistory();
  //const {setTimeActive} = useAuthValue()

  const inputRef = useRef(null);

  const handleChange = () => {
    if (inputRef.current) {
      const ref = inputRef.current;
      if (!ref.validity.valid) {
        setInputError(true);
      } else {
        setInputError(false);
      }
    }
  };

  const move = () => {
    history.push("/admin");
  };

  const validatePw = () => {
    let isValid = true;
    if (newPassword !== "" && confirmNewPassword !== "") {
      if (newPassword !== confirmNewPassword) {
        isValid = false;
        setMessage("パスワードが異なります");
      }
    }
    return isValid;
  };
  const changePw = (e) => {
    e.preventDefault();
    if (validatePw()) {
      setError("");

      const auth = getAuth();
      const user = auth.currentUser;

      const credential = EmailAuthProvider.credential(
        auth.currentUser.email,
        password
      );
      console.log(auth.currentUser.email);
      reauthenticateWithCredential(user, credential).then(() => {
        updatePassword(user, newPassword)
          .then(() => {
            setUpdated(true);
            console.log("success");
            setEmail("");
            setNewPassword("");
            setConfirmNewPassword("");
          })
          .catch((err) => {
            console.log(err.message);
          });
      });
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <AppBar position="absolute">
          <Toolbar
            sx={{
              pr: "24px", // keep right padding when drawer closed
            }}
          >
            <Typography
              component="h1"
              variant="h6"
              color="inherit"
              noWrap
              sx={{ flexGrow: 1 }}
            >
              SENKO-SO-MATCH(登録サイト)
            </Typography>
            <AdminMenu />
          </Toolbar>
        </AppBar>
        <List component="nav" sx={{ mt: 10, width: 240 }}>
          <AdminListItems />
          <Divider sx={{ my: 1 }} />
        </List>
        <Box
          component="main"
          sx={{
            backgroundColor: (theme) =>
              theme.palette.mode === "light"
                ? theme.palette.grey[100]
                : theme.palette.grey[900],
            flexGrow: 1,
            height: "100vh",
            overflow: "auto",
          }}
        >
          <Toolbar />
          <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={12} lg={12} xl={12}>
                <Paper
                  sx={{
                    mt: 2,
                    p: 2,
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Grid container spacing={1}>
                    <Grid container direction="column" alignItems="center">
                      <Grid
                        sx={{
                          width: "50%",
                          my: 8,
                          mx: 4,
                        }}
                      >
                        <Typography
                          component="h1"
                          variant="h5"
                          color="primary"
                          marginTop={3}
                          align="center"
                        >
                          {updated === true
                            ? "パスワード変更完了"
                            : "パスワードを変更いたします"}
                        </Typography>
                        <Typography
                          component="h1"
                          variant="subtitle1"
                          color="#000000"
                          marginTop={3}
                          align="center"
                          sx={{ width: "100%" }}
                        >
                          {updated === true
                            ? "パスワードの変更が完了いたしました"
                            : ""}
                        </Typography>
                        <Grid container direction="column" alignItems="center">
                          <Box
                            component="form"
                            noValidate
                            sx={{ mt: 1, width: "50%" }}
                            onSubmit={changePw}
                            name="login_form"
                          >
                            {inputError ? (
                              <div className="auth__error">
                                パスワードは8文字以上20
                                文字以下で入力してください
                              </div>
                            ) : (
                              ""
                            )}
                            {error && (
                              <div className="auth__error">{error}</div>
                            )}
                            {newPassword === confirmNewPassword
                              ? ""
                              : message && (
                                  <div className="auth__error">{message}</div>
                                )}
                            {updated === true ? (
                              ""
                            ) : (
                              <TextField
                                margin="normal"
                                type="password"
                                fullWidth
                                value={password}
                                required
                                label="現在のパスワード"
                                placeholder="現在のパスワード"
                                onChange={(e) => setPassword(e.target.value)}
                              />
                            )}
                            {updated === true ? (
                              ""
                            ) : (
                              <TextField
                                margin="normal"
                                type="password"
                                fullWidth
                                value={newPassword}
                                required
                                inputProps={{ maxLength: 20, minLength: 8 }}
                                inputRef={inputRef}
                                label="新しいパスワード"
                                placeholder="新しいパスワード"
                                autoFocus
                                onChange={(e) => {
                                  setNewPassword(e.target.value);
                                  handleChange();
                                }}
                              />
                            )}

                            {updated === true ? (
                              ""
                            ) : (
                              <TextField
                                margin="normal"
                                type="password"
                                fullWidth
                                value={confirmNewPassword}
                                required
                                inputProps={{ maxLength: 20, minLength: 8 }}
                                inputRef={inputRef}
                                label="新しいパスワード(確認)"
                                placeholder="新しいパスワード(確認)"
                                autoFocus
                                onChange={(e) => {
                                  setConfirmNewPassword(e.target.value);
                                  handleChange();
                                  validatePw();
                                }}
                              />
                            )}

                            {updated === true ? (
                              <Button
                                variant="contained"
                                fullWidth
                                color="success"
                                sx={{ mt: 3, mb: 2 }}
                                onClick={move}
                              >
                                トップページ ＞
                              </Button>
                            ) : password !== "" &&
                              newPassword !== "" &&
                              newPassword === confirmNewPassword ? (
                              <Button
                                variant="contained"
                                type="submit"
                                fullWidth
                                color="success"
                                sx={{ mt: 3, mb: 2 }}
                              >
                                送信
                              </Button>
                            ) : (
                              <Button
                                variant="contained"
                                disabled
                                fullWidth
                                color="success"
                                sx={{ mt: 3, mb: 2 }}
                              >
                                送信
                              </Button>
                            )}
                          </Box>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
            </Grid>
            <Copyright sx={{ pt: 2 }} />
          </Container>
        </Box>
      </Box>
    </ThemeProvider>
  );
}

export default AdminChangePW;
